import React from "react";
import "../Styles/Footer.css";

const Footer = (props) => {
  return (
    <>
      <div className="twoColContainerF">
        <div className="firstColHeaderF">
          <a href="https://twojeskd.pl">
            <img
              alt="logo"
              className="logoImageFooter"
              src="https://pskd.ftpeople.pl/wp-content/uploads/2023/12/logo.png.webp"
            />{" "}
          </a>
        </div>
        <div className="secondColHeaderF">
          <a
            className="contactHref"
            href="https://twojeskd.pl/polityka-prywatnosci/"
          >
            Polityka prywatności
          </a>
          <a className="contactHref" href="https://twojeskd.pl/regulamin/">
            Regulamin
          </a>
          <a className="contactHref" href="mailto: biuro@twojeskd.pl">
            biuro@twojeskd.pl
          </a>
          <a className="contactHref" href="https://twojeskd.pl/">
            © Twoje SKD 2024
          </a>
        </div>
      </div>
    </>
  );
};

export default Footer;
